module.exports = __webpack_public_path__ + "img/0-lg.4e7ff50d.jpg";